import { usePostShareableLinksMigrate } from "api/generated/shareable-links/shareable-links";

export function usePageStateMigrationMutation() {
    return usePostShareableLinksMigrate({
        mutation: {
            onError: (error) => {
                throw new Error(`Failed to migrate data`, error);
            },
        },
    });
}
